import axios from "axios";
import ApiBaseURLProps from "../other/apiBaseURL";
import { authorizationHeader, getAxios } from "./apiConfig";

class ApiService {
  getCountryList() {
    return getAxios(ApiBaseURLProps.apiBaseURL + "/lookup/country", {
      ...authorizationHeader(),
    });
  }

  getNationalityList() {
    return getAxios(ApiBaseURLProps.apiBaseURL + "/lookup/nationality", {
      ...authorizationHeader(),
    });
  }

  getStateList() {
    return getAxios(ApiBaseURLProps.apiBaseURL + "/lookup/state", {
      ...authorizationHeader(),
    });
  }
  getDistrictList() {
    return getAxios(ApiBaseURLProps.apiBaseURL + "/lookup/district", {
      ...authorizationHeader(),
    });
  }

  getMunicipalityList() {
    return getAxios(ApiBaseURLProps.apiBaseURL + "/lookup/municipality", {
      ...authorizationHeader(),
    });
  }

  getBankList() {
    return getAxios(ApiBaseURLProps.apiBaseURL + "/lookup/bank", {
      ...authorizationHeader(),
    });
  }

  getBankBranchList(bankCode) {
    return getAxios(
      ApiBaseURLProps.apiBaseURL + "/lookup/bank-branch/" + bankCode,
      {
        ...authorizationHeader(),
      }
    );
  }

  getAllBankBranchList(bankCode) {
    console.log(bankCode, "bank code");
    return getAxios(
      ApiBaseURLProps.apiBaseURL + "/lookup/all-bank-branch/" + bankCode,
      {
        ...authorizationHeader(),
      }
    );
  }

  getBankBranch() {
    return getAxios(ApiBaseURLProps.apiBaseURL + "/lookup/bank-branch/", {
      ...authorizationHeader(),
    });
  }

  getBankAccountTypeList() {
    return getAxios(ApiBaseURLProps.apiBaseURL + "/lookup/bank-account-type", {
      ...authorizationHeader(),
    });
  }

  getCompanyTypeList() {
    return getAxios(ApiBaseURLProps.apiBaseURL + "/lookup/company-type", {
      ...authorizationHeader(),
    });
  }

  getDesignationList() {
    return getAxios(ApiBaseURLProps.apiBaseURL + "/lookup/designation", {
      ...authorizationHeader(),
    });
  }

  getFinancialDetailsList() {
    return getAxios(ApiBaseURLProps.apiBaseURL + "/lookup/financial-details", {
      ...authorizationHeader(),
    });
  }
  getRelationTypeList() {
    return getAxios(ApiBaseURLProps.apiBaseURL + "/lookup/relation-type", {
      ...authorizationHeader(),
    });
  }

  getBusinessTypeList() {
    return getAxios(ApiBaseURLProps.apiBaseURL + "/lookup/business-type", {
      ...authorizationHeader(),
    });
  }

  getOccupationTypeList() {
    return getAxios(ApiBaseURLProps.apiBaseURL + "/lookup/occupation-type", {
      ...authorizationHeader(),
    });
  }

  getDocumentTypeList() {
    return getAxios(ApiBaseURLProps.apiBaseURL + "/lookup/document-type", {
      ...authorizationHeader(),
    });
  }

  getKycPanList(pan) {
    return getAxios(ApiBaseURLProps.apiBaseURL + "/kyc/ird/pan/" + pan, {
      ...authorizationHeader(),
    });

  }

  getStateListByCountryCode(param) {
    return getAxios(
      ApiBaseURLProps.apiBaseURL + "/lookup/state-by-country/" + param,
      {
        ...authorizationHeader(),
      }
    );
  }

  getDistrictListByStateCode(param) {
    return getAxios(
      ApiBaseURLProps.apiBaseURL + "/lookup/district-by-state/" + param,
      {
        ...authorizationHeader(),
      }
    );
  }

  getMunicipalityListByDistrictCode(param) {
    return getAxios(
      ApiBaseURLProps.apiBaseURL + "/lookup/municipality-by-district/" + param,
      {
        ...authorizationHeader(),
      }
    );
  }

  getDpList() {
    return getAxios(
      ApiBaseURLProps.apiBaseURL + "/security/organizations/dp",
      {
        ...authorizationHeader(),
      }
    );
  }

  async getDynamicFieldList() {
    return getAxios(ApiBaseURLProps.apiBaseURL + "/lookup/dynamic/field", {
      ...authorizationHeader(),
    });
    // return await {
    //   data: {
    //     data: [
    //       {
    //         dynamicKey: "name",
    //         label: "Name",
    //         sectionId: 1,
    //       },
    //       {
    //         dynamicKey: "phone",
    //         label: "Phone",
    //         type: "number",
    //         validation: { max: 10, min: 1 },
    //         sectionId: 4,
    //       },
    //       {
    //         dynamicKey: "gender",
    //         label: "Gender",
    //         type: "radio",
    //         possibleValues: [
    //           { value: "M", label: "Male" },
    //           { value: "F", label: "Female" },
    //           { code: "O", label: "Other" },
    //         ],
    //         sectionId: 4,
    //       },
    //     ],
    //   },
    // };
  }

  async getSectionList(formType) {
    return await {
      data: {
        data: [
          {
            id: 1,
            code: "PD",
            route: "/kyc/person",
            icon: "pi-user",
            text: "Personal details",
            textNep: "व्यक्तिगत विवरण",
            type: "I",
          },
          {
            id: 2,
            code: "CD",
            route: "/kyc/company",
            icon: "pi-th-large",
            text: "Company details",
            textNep: "कम्पनी विवरण",
            type: "C",
          },
          {
            id: 4,
            code: "AD",
            route: "/kyc/address",
            icon: "pi-map-marker",
            text: "Address details",
            textNep: "ठेगाना विवरण",
          },
          {
            id: 5,
            code: "DD",
            route: "/kyc/director",
            icon: "pi-users",
            text: "Director details",
            textNep: "निर्देशक विवरण",
            type: "C",
          },
          {
            id: 6,
            code: "FD",
            route: "/kyc/family",
            icon: "pi-users",
            text: "Family details",
            textNep: "परिवार विवरण",
            type: "I",
          },
          {
            id: 7,
            code: "BKD",
            route: "/kyc/bank",
            icon: "pi-credit-card",
            text: "Bank details",
            textNep: "बैंक विवरण",
          },
          {
            id: 8,
            code: "OD",
            route: "/kyc/occupation",
            icon: "pi-briefcase",
            text: "Occupation details",
            textNep: "पेशागत विवरण",
            type: "I",
          },

          {
            id: 3,
            code: "BD",
            route: "/kyc/boid",
            icon: "pi-chart-bar",
            text: "BOID details",
            textNep: "हितग्राही खाता विवरण",
          },

          {
            id: 11,
            code: "MLD",
            route: "/kyc/money-laundering-prevention",
            icon: "pi-money-bill",
            text: "Money Laundering Declaration",
            textNep: "सम्पत्ति शुद्धिकरण विवरण",
            type: "I",
          },
          {
            id: 9,
            code: "GD",
            route: "/kyc/guardian",
            icon: "pi-shield",
            text: "Guardian details",
            textNep: "संरक्षक विवरण",
            type: "I",
          },
          {
            id: 10,
            code: "DOD",
            route: "/kyc/document",
            icon: "pi-file",
            text: "Document details",
            textNep: "कागजात विवरण",
          },
          {
            id: 13,
            code: "BID",
            route: "/kyc/biometrics",
            icon: "pi-check-square",
            text: "Biometrics",
            textNep: "Biometrics",
          },
          {
            id: 12,
            code: "DE",
            route: "/kyc/decleration",
            icon: "pi-check-square",
            text: "Declaration",
            textNep: "स्वघोषणा",
          },
        ].filter((data) => !data.type || data.type === formType),
      },
    };
  }

  getDirectorTypeList() {
    return getAxios(ApiBaseURLProps.apiBaseURL + "/lookup/director-type/", {
      ...authorizationHeader(),
    });
  }
  getOrganizationDocumentTypeList() {
    return getAxios(
      ApiBaseURLProps.apiBaseURL + "/security/organizations/document-type",
      {
        ...authorizationHeader(),
      }
    );
  }
  checkBoIdInOldDB(
    boid,
    name,
    fatherName,
    grandFatherName,
    citizenshipNo,
    dob
  ) {
    return getAxios(
      ApiBaseURLProps.apiBaseURL +
      "/kyc/check-boid?boidLs=" +
      boid +
      "&name=" +
      name +
      "&fatherName=" +
      fatherName +
      "&grandFatherName=" +
      grandFatherName +
      "&citizenshipNo=" +
      citizenshipNo +
      "&dob=" +
      dob,
      {
        ...authorizationHeader(),
      }
    );
  }
  checkBoid(boid, dpId) {
    return getAxios(
      ApiBaseURLProps.apiBaseURL +
      "/kyc/find/boId?boId=" +
      boid +
      "&dpId=" +
      dpId,
      {
        ...authorizationHeader(),
      }
    );
  }

  getOfficeList() {
    return getAxios(
      ApiBaseURLProps.apiBaseURL + "/lookup/office",
      {
        ...authorizationHeader(),
      }
    );
  }

  checkBoidValidity(id, boidList, params) {
    return getAxios(
      ApiBaseURLProps.apiBaseURL +
      "/kyc/check-boid?customerId=" + id + "&boIdLs=" +
      boidList.join(',')
      +
      Object.keys(params)
        .map((k) => "&" + k + "=" + (params[k] || ''))
        .filter(k => k !== 'dob' || params[k])
        .reduce((a, v) => a + v, ""),
      {
        ...authorizationHeader(),
      }
    );
  }
  getQRInfo(permKycId) {
    return getAxios(
      ApiBaseURLProps.apiBaseURL + "/kyc/qr-code?permKycId=" + permKycId,
    );
  }


  getSchedulesByDp() {
    return getAxios(
      ApiBaseURLProps.apiBaseURL + "/video-kyc/kycVideo/kyc-video-session-by-orgId",
    );
  }
  getScheduleSlots(scheduleId) {
    return getAxios(
      ApiBaseURLProps.apiBaseURL + "/video-kyc/kycVideo/scheduleSlots?scheduleId=" + scheduleId,
    );
  }
  getVideoKycEvent() {
    return getAxios(
      ApiBaseURLProps.apiBaseURL + "/video-kyc/kycVideo/scheduleDetails",
    );
  }
  checkCancelledMoreThan5() {
    return getAxios(
      ApiBaseURLProps.apiBaseURL + "/video-kyc/kycVideo/checkCancelledRepeat",
    );
  }
  getGlobalSetting() {
    return getAxios(ApiBaseURLProps.apiBaseURL + "/lookup/setting/global");
  }

  getGlobalSettingPublic() {
    return getAxios(ApiBaseURLProps.apiBaseURL + "/lookup/setting");
  }

  //for duplicate check:

  getCustomerGeneratedBoid(id) {
    return getAxios(
      ApiBaseURLProps.apiBaseURL + "/kyc/customer-generated-boid?id=" + id
    );
  }

  getDuplicateDataByBoids(boidList) {
    return getAxios(
      ApiBaseURLProps.apiBaseURL + "/kyc/duplicate-list-boid?boIdList=" + boidList.join(',')
    );
  }

  getDuplicateDataByCustomer(id) {
    return getAxios(
      ApiBaseURLProps.apiBaseURL + "/kyc/duplicate-ckyc-id?id=" + id
    );
  }
  // getAiAnalysisCustomer(id) {
  //   return getAxios(
  //     ApiBaseURLProps.apiBaseURL + "/kyc/anarlysis-ai?id=" + id
  //   );
  // }

  getConflictingData(params, page, size) {
    const url = "/kyc/duplicate-list-page";
    return getAxios(ApiBaseURLProps.apiBaseURL +
      `${url}?page=${page || 0}&size=${size || 10}` +
      Object.keys(params)
        .filter((k) => params[k] != null)
        .map((k) => "&" + k + "=" + params[k])
        .reduce((a, v) => a + v, ""),
      {
        headers: {
          Authorization: "Bearer " + sessionStorage.getItem("token"),
        },
      })
    // return axios.get(
    //   ApiBaseURLProps.apiBaseURL +
    //   `${url}?page=${page || 0}&size=${size || 10}` +
    //   Object.keys(params)
    //     .filter((k) => params[k] != null)
    //     .map((k) => "&" + k + "=" + params[k])
    //     .reduce((a, v) => a + v, ""),
    //   {
    //     headers: {
    //       Authorization: "Bearer " + sessionStorage.getItem("token"),
    //     },
    //   }
    // );
  }

  getKycInfoData(isClean, customerIds) {
    return getAxios(ApiBaseURLProps.apiBaseURL + `/kyc/customer-info-${isClean ? 'clean' : 'dirty'}?customerIds=` + customerIds.split(',').filter(c => c).join(','));
  }
}
export default new ApiService();
